import { baseApi } from './BaseApi';
/**
 *
 */
export const ProductAssignmentService = {
  get: {
    all: (params?: {}) => {
      return baseApi.get('/api/product/getAllProducts', { params: params });
    },
    pages: {
      list: (params?: {}) => {
        return baseApi.get('/api/product/getListProductPage', { params: params });
      },
      products: (params?: {}) => {
        return baseApi.get('/api/product/getProductsByProductPage', { params: params });
      }
    },
    collections: {
      list: (params?: {}) => {
        return baseApi.get('/api/product/getListShopifyCollection', { params: params });
      },
      products: (params?: {}) => {
        return baseApi.get('/api/product/getProductsByShopifyCollection', { params: params });
      }
    },
  } as any,
  
  updatePageAssignment: (pageId: any, params?: {}) => {
    return baseApi.post(`/api/pages/${pageId}/page-assignment`, params);
  },

  getLastestProduct: (params?: {}) => {
    return baseApi.get('/api/product/getProduct?productId=latest', { params: params });
  },

  getAssignedProduct: (params?: {}) => {
    return baseApi.get('/api/product/getAssignedProducts', { params: params });
  },
};
